import { useTranslation } from "react-i18next";

const SeaShipping = () => {
  const { t } = useTranslation();
  return (
    <main className="px-10 py-20 space-y-4">
      <h1 className=" font-semibold text-[32px] text-center pb-10 ">
        {t("seaShipping")}
      </h1>
      <header class="min-h-[100px] md:h-[70vh] overflow-hidden rounded-lg ">
        <img
          src="/assets/seaShipping.webp"
          alt="الشحن البحري"
          class="w-full h-full object-cover"
        />
      </header>
      <h2 className="text-mainRed text-[20px] my-4 font-bold">{t("seaShipping1")}</h2>
      <p className="py-3 text-xl font-medium leading-relaxed text-gray-800">
        {t("shipping_intro")}
      </p>
      <div>
        <h4 className="py-3 text-xl font-semibold text-gray-600">
          {t("seaAdvantages")}:
        </h4>
        <ol class="list-decimal pl-6 space-y-2">
          <li class="font-medium leading-7 text-gray-700">
            {t("seaShippingCostEfficiencyText")}
          </li>
          <li class="font-medium leading-7 text-gray-700">
            {t("seaShippingLargeCapacityText")}
          </li>
          <li class="font-medium leading-7 text-gray-700">
            {t("seaShippingGlobalReachText")}
          </li>
          <li class="font-medium leading-7 text-gray-700">
            {t("seaShippingEnvironmentalImpactText")}
          </li>
          <li class="font-medium leading-7 text-gray-700">
            {t("seaShippingSafetyReliabilityText")}
          </li>
        </ol>
      </div>
      <div>
        <h4 className="py-3 text-xl font-semibold text-gray-600">
          {t("seaShippingTypes")}:
        </h4>
        <ol class="list-decimal pl-6 space-y-2">
          <li class="font-medium leading-7 text-gray-700">
            {t("seaShippingTypeFCLText")}
          </li>
          <li class="font-medium leading-7 text-gray-700">
            {t("seaShippingTypeLCLText")}
          </li>

          <li class="font-medium leading-7 text-gray-700">
            {t("seaShippingTypeBulkText")}
          </li>
          <li class="font-medium leading-7 text-gray-700">
            {t("seaShippingTypeRoRoText")}
          </li>
        </ol>
      </div>
      <div>
        <h4 className="py-3 text-xl font-semibold text-gray-600">
          {t("seaShippingAndLogistics")}:
        </h4>
        <p className="font-medium leading-7 text-gray-700">
          {t("seaShippingAndLogisticsText")}
        </p>
        <p className="font-medium leading-7 text-gray-700">
          {t("seaShippingEvolutionSustainabilityText")}
        </p>
      </div>
      <div>
        <h4 className="py-3 text-xl font-semibold text-gray-600">
          {t("seaShippingChallengesTitle")}:
        </h4>
        <p className="font-medium leading-7 text-gray-700">
          {t("seaShippingChallengesText")}
        </p>
      </div>
    </main>
  );
};

export default SeaShipping;
